import { theme } from "../../globals/theme";
export const foreColorChecked = (isChecked: boolean) => {
  if (isChecked) {
    return {
      color: theme.palette.foreColor.main,
    };
  } else {
    return {
      color: theme.palette.foreColor.dark,
    };
  }
};
